import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { deleteCustomer } from '../api/customersApi';

// Backend broadcasts UpdateCustomerTable / UpdateQuoteTable / UpdateJobTable
// on successful delete, so useCustomers / useQuotes / useJobs will self-
// invalidate. We only need to drop the per-id ['customer', id] cache here
// so a back-nav to the deleted customer doesn't flash stale data before the
// 404 lands.
export default function useDeleteCustomer() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteCustomer,
        onSuccess: (_data, id) => {
            queryClient.removeQueries({ queryKey: ['customer', id] });
            toast.success('Customer deleted');
        },
        onError: (err) => toast.error(err?.message ?? 'Failed to delete customer'),
    });
}
